import { type SupportedLocation } from '../location/constants';

import { FooterUpperConfig } from './constants';

export function getFooterConfig(location: SupportedLocation) {
  return FooterUpperConfig.map((column) => ({
    ...column,
    children: column.children.filter(
      ({ locations }) => !locations || locations.includes(location)
    ),
  })).filter((column) => column.children.length > 0);
}
